// extracted by mini-css-extract-plugin
module.exports = {"clientTable":"NeedsApproval_clientTable__Q7By-","report__filter":"NeedsApproval_report__filter__cF7Yl"};